<script setup lang="ts"></script>

<template>
  <section>
    <v-container>
      <div class="public-map-loader" aria-hidden="true">
        <v-skeleton-loader class="public-map-loader-skeleton" type="image" />
      </div>
    </v-container>
  </section>
</template>

<style lang="scss" scoped>
.public-map-loader {
  display: flex;
  justify-content: center;
  margin-bottom: 150px;
  height: 500px;

  @include media('sm-and-up') {
    height: 560px;
  }

  @include media('md-and-up') {
    height: 700px;
  }
}

.public-map-loader-skeleton {
  width: 100%;
  height: 100%;
}

.public-map-loader-skeleton :deep(.v-skeleton-loader__image) {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
</style>
